import React from "react";
import {useContainerMediaQueriesChecks} from "../../hooks/use-container-media-queries-checks.hook";
import {computePaymentMethodIconSize} from "./compute-payment-method-icon-size";
import {observer} from "mobx-react";
import {
    ICardNetworkIconOptions
} from "../../services/booking/models/payment/methods/card/networks/card-network.view-model.interface";


export const LogoDinersIcon: React.FC<ICardNetworkIconOptions> = observer((props) => {
    const styles = {
        a: { fill: '#0079be' },
        b: { fill: '#fff' },
    };

    return (
        <svg
            {...computePaymentMethodIconSize(useContainerMediaQueriesChecks(), props)}
            version="1.2"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 750 471"
        >
            <path
                style={styles.a}
                d="m671.7 237.5c0-140.4-117.3-237.5-245.8-237.5h-110.5c-130.1 0-237.1 97.1-237.1 237.5 0 128.5 107.1 234.1 237.1 233.5h110.5c128.5 0.6 245.8-105 245.8-233.5z"
            />
            <path
                style={styles.b}
                fillRule="evenodd"
                d="m316.1 451.1c-119 0-215.2-96.4-215.2-215.6 0-119.2 96.2-215.6 215.2-215.6 118.9 0 215.1 96.4 215.1 215.6 0 119.2-96.2 215.6-215.1 215.6z"
            />
            <path
                style={styles.a}
                d="m180.1 234.9c0.1-58.2 36.4-107.8 87.5-127.5v255c-51.1-19.7-87.4-69.3-87.5-127.5zm185.1 127.6v-255.1c51.2 19.7 87.5 69.3 87.6 127.5-0.1 58.3-36.4 107.9-87.6 127.6z"
            />
        </svg>
    );
});
